/* eslint-disable eqeqeq */
import React, {useEffect, useState, useRef, useCallback, useMemo} from 'react'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {useTranslation} from 'react-i18next'
import axios from 'axios'
import Pagination from '../../../component/Pagination'
import {updateById, deleteById} from '../../../../../api/modules/configuration/signing'
import swal from 'sweetalert'
import {Spinner} from 'react-bootstrap'
import {useAppDispatch, useAppSelector} from '../../../../../redux/hooks'
import {objToParams} from '../../../../../utils/objToParams'
import {fetchConfigSigning, headers} from '../../../../../services/fetcher'
import {RowFilter} from './RowFilter'
import {RowHead} from './RowHead'
import {ButtonGroups} from './ButtonGroups'
import {
  filterSelector,
  resetFilterConfigLetter,
  setIsFetchData,
} from '../../../../../redux/slices/filterSlices'
import * as TableUI from '../../../../../components/Table/Table'
import {useRowTable} from '../../../../../hooks/useRowTable'
import {StyledCard} from '../../../../../components/StyledCard'
import {RowData, RowDataProps} from './RowData'
import {useLoaderList} from 'src/hooks/useLoaderList'
import Checkbox from 'src/app/pages/access/Checkbox'
import {MultiSelect} from 'react-multi-select-component'
import {getSalesAreaLetter, getSectorAll} from 'src/api/modules/getdatalist'
import {getFilterCityMasterData, getRegionAllMasterData} from 'src/api/modules/master-data/master_2'
import {getMaterialGroup} from 'src/api/modules/master-data/master'
import i18next from 'i18next'

type Props = {
  className: string
}

const Table: React.FC<Props> = ({className}) => {
  const {t} = useTranslation()
  const {filterConfigSigning: filter} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()

  const {RowEmptyData, RowErrorFetch, RowLoader} = useRowTable({
    colSpan: 9,
    onReloadTable: () => dispatch(resetFilterConfigLetter()),
  })

  const {
    isLoadingEditButton,
    onInitializeLoaderList,
    onResetLoaderList,
    onUpdateLoaderListByIndex,
  } = useLoaderList()

  const [page, setPage] = useState(0)
  const [btnLoading, setBtnLoading] = useState(false)
  const [numberURL, setNumberURL] = useState([])

  const [fullSales, setFullSales] = useState<any[]>([])
  const [material, setMaterial] = useState([])
  const [fullSektor, setFullSektor] = useState([])

  const [sales, setSales] = useState<any[]>([])
  const [module, setModule] = useState('')
  const [productType, setProductType] = useState<any[]>([])
  const [sektor, setSektor] = useState<any[]>([])
  const [tonnageLimitActive, setTonnageLimitActive] = useState(false)
  const [tonnageLimitFrom, setTonnageLimitFrom] = useState('')
  const [tonnageLimitTo, setTonnageLimitTo] = useState('')
  const [signerName, setSignerName] = useState('')
  const [signerPosition, setSignerPosition] = useState('')
  const [regions, setRegions] = useState<any[]>([])
  const [cities, setCities] = useState<any>([])
  const [regionCode, setRegionCode] = useState<any>([])
  const [cityCode, setCityCode] = useState<any[]>([])
  const [regionCreate, setRegionCreate] = useState<any>('')
  const [status, setStatus] = useState(true)

  const [tempID, setTempID] = useState(0)
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  const [allConfig, setAllConfig] = useState([])
  const [showEdit, setShowEdit] = useState(false)
  const [showDelete, setShowDelete] = useState(false)

  const [listmodule] = useState([
    {value: 'sip', label: 'SIP'},
    {value: 'contract', label: 'SKPP'},
    {value: 'so', label: 'SO'},
  ])
  const [listlang] = useState([
    {value: 'id', label: 'Indonesia'},
    {value: 'en', label: 'English'},
  ])

  const rowNumber = useMemo(() => {
    const per = filter?.per_page ?? 5
    return page * per - per
  }, [filter, page])

  useEffect(() => {
    const getSales = async () => {
      await getSalesAreaLetter().then((res: any) => {
        setFullSales(res.data.data)
      })
    }
    const getRegion = async () => {
      const res = await getRegionAllMasterData()
      const data = res.data.data
      setRegions(data)
    }
    const getMaterial = async () => {
      const res = await getMaterialGroup()
      setMaterial(res.data.data)
    }
    const getSector = async () => {
      const res = await getSectorAll()
      setFullSektor(res.data.data)
    }

    getRegion()
    getSales()
    getMaterial()
    getSector()
  }, [])

  const editorRef: any = useRef()

  const handleEdit = async () => {
    await updateById(tempID, {
      module,
      sector_ids: sektor.map((item: any) => item.value),
      sales_org_codes: sales.map((item: any) => item.value),
      product_types: productType.map((item: any) => item.value),
      province_ids: regionCode.map((item: any) => item.value),
      city_ids: cityCode.map((item: any) => item.value),
      quantum_limition: tonnageLimitActive,
      quantum1: tonnageLimitActive ? tonnageLimitFrom : null,
      quantum2: tonnageLimitActive ? tonnageLimitTo : null,
      signer_name: signerName,
      signer_position: signerPosition,
      is_active: status ? 1 : 0,
      lang: i18next.language,
      credentials: localStorage.getItem('credential'),
    })
      .then(() => {
        onFetchConfigSigning()
        swal({
          title: `${t('configuration signing Edited')}`,
          icon: 'success',
        }).then(() => {
          setActived(!actived)
          setShowEdit(false)
        })
      })
      .catch((error: any) => {
        swal({
          closeOnClickOutside: false,
          title: t(error.response.data.message),
          icon: 'error',
        })
      })
  }

  const handleDelete = async (id: any) => {
    swal({
      title: t('Are you sure?'),
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Yes')}`],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        await deleteById(id)
          .then((res: any) => {
            onFetchConfigSigning()
            swal({
              title: t('configuration signing Deleted'),
              icon: 'success',
            })
            setShowDelete(false)
            setActived(!actived)
          })
          .catch(function (error: any) {
            if (error.response) {
              swal({
                title: `${error.response.data.message}`,
                icon: 'error',
              })
            }
          })
          .finally(() => {
            setBtnLoading(false)
          })
      }
    })
  }

  const dropConfig = async () => {
    setBtnLoading(true)
    await deleteById(tempID)
      .then((res: any) => {
        swal({
          title: t('configuration signing Deleted'),
          icon: 'success',
        })
        setShowDelete(false)
        setActived(!actived)
      })
      .catch(function (error: any) {
        if (error.response) {
          swal({
            title: `${error.response.data.message}`,
            icon: 'error',
          })
        }
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const paginateNumber = async (url: string) => {
    try {
      setIsLoading(true)

      const token = localStorage.getItem('token') as string
      const credentials = localStorage.getItem('credential') as string
      const endpoint = `${url}&credentials=${credentials}&${objToParams(filter)}`
      const res = await axios.get(endpoint, {
        headers: {...headers, Authorization: `Bearer ${token}`},
      })

      setAllConfig(res.data.data.data)
      setPage(res.data.data.current_page)
      setNumberURL(res.data.data.links)
      onInitializeLoaderList(res.data.data.data)
    } catch (error) {
      setIsError(true)
    } finally {
      setIsLoading(false)
    }
  }

  const [actived, setActived] = useState(false)

  const handleClickTonnageLimitActive = (e: any) => {
    setTonnageLimitActive(e.target.checked)
  }

  const handleClickStatus = (e: any) => {
    setStatus(e.target.checked)
  }

  const handleRegion = async (e: any = null) => {
    let selectedRegion = []
    if (e != null) {
      setRegionCode([...e])
      selectedRegion = [...e].map((item: any) => item.value)
    } else {
      selectedRegion = regionCode
    }
    let arr: any = []
    let getRegionValue = selectedRegion.join(',')
    arr.push(selectedRegion)

    setRegionCreate(arr[0])
    await getFilterCityMasterData(getRegionValue).then((res: any) => {
      const data = res.data.data
      setCities(data)
    })
  }

  const onEdit = (data: RowDataProps['data']) => {
    setTempID(data?.id)
    setModule(data?.module ?? '')
    setSektor(
      data?.sectors.map((item) => {
        return {
          value: item.id,
          label: item.name,
        }
      })
    )
    setSales(
      data?.sales_orgs.map((item) => {
        return {
          value: item.code,
          label: item.name,
        }
      })
    )
    setProductType(
      data?.product_types.map((item) => {
        return {
          value: item.material_group,
          label: item.product_type,
        }
      })
    )

    setRegionCode(
      data.provinces?.map((item) => {
        return {
          value: item.id,
          label: item.region_name,
        }
      })
    )
    handleRegion()
    setCityCode(
      data.cities?.map((item) => {
        return {
          value: item.id,
          label: item.city_name,
        }
      })
    )

    setTonnageLimitActive(data.quantum_limition == 1 ? true : false)
    setTonnageLimitFrom(data?.quantum1 ?? '')
    setTonnageLimitTo(data?.quantum2 ?? '')
    setStatus(data.is_active == 1 ? true : false)

    setSignerName(data?.signer_name ?? '')
    setSignerPosition(data?.signer_position ?? '')
    setShowEdit(true)
  }

  const onDelete = (data: RowDataProps['data']) => {
    setTempID(data.id)
    handleDelete(data.id)
  }

  const onFetchConfigSigning = useCallback(() => {
    setIsLoading(true)
    setIsError(false)

    fetchConfigSigning(filter)
      .then((res: any) => {
        setAllConfig(res.data.data.data)
        setPage(res.data.data.current_page)
        setNumberURL(res.data.data.links)
        onInitializeLoaderList(res.data.data.data)
      })
      .catch(() => setIsError(true))
      .finally(() => {
        setIsLoading(false)
        dispatch(setIsFetchData(false))
      })
  }, [filter, dispatch])

  useEffect(() => {
    const getData = setTimeout(onFetchConfigSigning, 1000)
    return () => clearTimeout(getData)
  }, [onFetchConfigSigning])

  const handleResetTable = () => {
    dispatch(resetFilterConfigLetter())
  }

  useEffect(() => {
    return () => {
      handleResetTable()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <StyledCard>
      <ButtonGroups />

      <TableUI.TableWrapper>
        <TableUI.Table>
          <TableUI.THead>
            <RowHead />
          </TableUI.THead>
          <TableUI.TBody>
            <RowFilter />
            {isLoading ? (
              <RowLoader />
            ) : isError ? (
              <RowErrorFetch />
            ) : allConfig.length === 0 ? (
              <RowEmptyData />
            ) : (
              allConfig.map((data: any, idx: number) => (
                <RowData
                  key={idx}
                  data={data}
                  rowNumber={idx + rowNumber + 1}
                  isLoadingEditButton={isLoadingEditButton(idx)}
                  onEdit={() => {
                    onEdit(data)
                    // onUpdateLoaderListByIndex(idx)
                  }}
                  onDelete={() => onDelete(data)}
                />
              ))
            )}
          </TableUI.TBody>
        </TableUI.Table>
      </TableUI.TableWrapper>

      <Pagination paginate={paginateNumber} test={numberURL} />

      <Modal
        show={showEdit}
        onHide={() => setShowEdit(false)}
        backdrop='static'
        keyboard={false}
        centered
        size='lg'
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {t('Edit')} {t('CONFIG.SIGNING.TITLE')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className='mb-5' controlId='formBasicPassword'>
            <Form.Label>{t('Module')}</Form.Label>
            <Form.Select
              aria-label='Default select example'
              defaultValue={module}
              onChange={(e: any) => setModule(e.target.value)}
            >
              <option value='SIP'>SIP</option>
              <option value='SKPP'>SKPP</option>
              <option value='SO'>SO</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className='mb-5' controlId='formBasicPassword'>
            <Form.Label>{t('Sector')}</Form.Label>
            <MultiSelect
              options={fullSektor?.map((item: any) => {
                return {label: t(item.name), value: item.id}
              })}
              value={sektor}
              onChange={setSektor}
              labelledBy='Select'
            />
          </Form.Group>

          {module != 'SIP' && (
            <>
              <Form.Group className='mb-5' controlId='formBasicPassword'>
                <Form.Label>Sales Org</Form.Label>
                <MultiSelect
                  options={fullSales?.map((item: any) => {
                    return {label: t(item.name), value: item.code}
                  })}
                  value={sales}
                  onChange={setSales}
                  labelledBy='Select'
                />
              </Form.Group>

              <Form.Group className='mb-5'>
                <Form.Label>{t('Product-Type')}</Form.Label>
                <MultiSelect
                  options={material?.map((item: any) => {
                    return {
                      label: t(item.material_group_desc),
                      value: item.material_group,
                    }
                  })}
                  value={productType}
                  onChange={setProductType}
                  labelledBy='Select'
                />
              </Form.Group>

              <Form.Group className='mb-5'>
                <Form.Label>{t('sub-order-provinsi')}</Form.Label>
                <MultiSelect
                  options={regions.map((item: any) => {
                    return {
                      value: item.id,
                      label: item.value,
                    }
                  })}
                  value={regionCode}
                  onChange={handleRegion}
                  labelledBy='Select'
                />
              </Form.Group>

              <Form.Group className='mb-5'>
                <Form.Label>{t('sub-order-kota')}</Form.Label>
                <MultiSelect
                  options={cities?.map((item: any) => {
                    return {label: item.value, value: item.id}
                  })}
                  value={cityCode}
                  onChange={setCityCode}
                  labelledBy='Select'
                />
              </Form.Group>
            </>
          )}

          <Form.Group className='mb-5'>
            <Checkbox
              id='checkbox-tonnage-limit-active'
              type='checkbox'
              name='tonnage-limit'
              handleClick={handleClickTonnageLimitActive}
              isChecked={tonnageLimitActive}
            />
            <Form.Label className='ms-3'>{t('Batasan Tonase')}</Form.Label>
          </Form.Group>

          {tonnageLimitActive && (
            <Row>
              <Col md={6}>
                <Form.Group className='mb-5'>
                  <Form.Label>{t('Minimal') + ' ' + t('sub-order-kuantum')}</Form.Label>
                  <Form.Control
                    id='quantum_1'
                    type='number'
                    min='0'
                    placeholder={t('Minimal') + ' ' + t('sub-order-kuantum')}
                    value={tonnageLimitFrom}
                    onChange={(e: any) => setTonnageLimitFrom(e.target.value)}
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className='mb-5'>
                  <Form.Label>{t('Maksimal') + ' ' + t('sub-order-kuantum')}</Form.Label>
                  <Form.Control
                    id='quantum_2'
                    type='number'
                    min='0'
                    placeholder={t('Maksimal') + ' ' + t('sub-order-kuantum')}
                    value={tonnageLimitTo}
                    onChange={(e: any) => setTonnageLimitTo(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
          )}

          <Form.Group className='mb-5'>
            <Form.Label>{t('Assigner Name')}</Form.Label>
            <Form.Control
              id='signer_name'
              type='text'
              placeholder={t('Assigner Name')}
              value={signerName}
              onChange={(e: any) => setSignerName(e.target.value)}
            />
          </Form.Group>

          <Form.Group className='mb-5'>
            <Form.Label>{t('Assigner Position')}</Form.Label>
            <Form.Control
              id='signer_position'
              type='text'
              placeholder={t('Assigner Position')}
              value={signerPosition}
              onChange={(e: any) => setSignerPosition(e.target.value)}
            />
          </Form.Group>

          <Form.Group className='mb-5'>
            <Checkbox
              id='checkbox-status'
              type='checkbox'
              name='status'
              handleClick={handleClickStatus}
              isChecked={status}
            />
            <Form.Label className='ms-3'>{t('activate')}</Form.Label>
          </Form.Group>

          <div className='d-flex justify-content-end'>
            <Button variant='primary' onClick={() => handleEdit()} disabled={btnLoading}>
              {btnLoading ? (
                <Spinner animation='border' variant='light' size='sm' />
              ) : (
                <>{t('Edit')}</>
              )}
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={showDelete} onHide={() => setShowDelete(false)} centered backdrop='static'>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <h3 className='text-center mb-5'>
            {t('Hapus')} {t('CONFIG.SIGNING.TITLE')}?
          </h3>
          <div className='d-flex justify-content-center'>
            <Button variant='secondary me-2' onClick={() => setShowDelete(false)}>
              {t('Tidak')}
            </Button>
            <Button variant='danger' onClick={() => dropConfig()} disabled={btnLoading}>
              {btnLoading ? <Spinner animation='border' variant='light' size='sm' /> : t('Ya')}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </StyledCard>
  )
}

export {Table}
